import React, { memo, useContext, useEffect, useState } from 'react'
import * as THREE from "three";
import { GVarState } from '../StoreState/Gstate';

function ShowPathIcon() {
    let g = useContext(GVarState);
    const [texture, settexture] = useState(null)
    const [escalatorDown, setEscalatorDown] = useState(null)
    const [escalatorUp, setEscalatorUp] = useState(null)
    const [elevator, setElevator] = useState(null)
    const [iconArray, setIconArray] = useState([])
    useEffect(() => {
        const loader = new THREE.TextureLoader();
        const escUp = loader.load("/icon/escalator.png");
        // const escDown = loader.load("/icon/escalator.png");
        const eleIcon = loader.load("icon/elevator.png")
        setEscalatorUp(escUp)
        setEscalatorDown(escUp)
        setElevator(eleIcon)
    }, [])


    useEffect(() => {
        
        // findindex, findlastIndex

        let index1 = g.pathAllPoint.findIndex(point=>point.z === g.CurrentFloor)
        let index2 = g.pathAllPoint.findLastIndex(point=>point.z === g.CurrentFloor)
        let firstPointIndex = g.pathAllPoint[index1]
        let seconfPointIndex = g.pathAllPoint[index2]
        
        
        if(!firstPointIndex && !seconfPointIndex){
            setIconArray([])
            return
        }
        let firstpoint = g.nodePoint[`${firstPointIndex.x},${firstPointIndex.y},${firstPointIndex.z}`]
        let lastpoint = g.nodePoint[`${seconfPointIndex.x},${seconfPointIndex.y},${seconfPointIndex.z}`]
        let iconData = [{...firstpoint.point,click:'pre'}, {...lastpoint.point,click:'next'}]

        
        

        
        window.iconData = iconData
        setIconArray([...iconData])

    }, [g.pathAllPoint, g.CurrentFloor])

    return (
        <>
            

            {iconArray.length && escalatorDown && escalatorUp && elevator &&
                iconArray.map((icon,index)=>{
                    if(icon.type === 'Escalator'){
                        return (
                            <sprite key={index} position={[(icon.x/10), 4, icon.y/10]} scale={3} visible={true} onClick={()=>{
                                if(icon.click === 'next'){
                                    g.setCurrentFloor(g.NextPrev[g.NextPrev.indexOf(g.CurrentFloor) + 1])
                                }else{
                                    g.setCurrentFloor(g.NextPrev[g.NextPrev.indexOf(g.CurrentFloor) - 1])
                                }
                            }}>
                                <spriteMaterial attach="material" map={escalatorUp} />
                            </sprite> 
                        )
                    
                    }
                    if(icon.type === 'Elevator'){
                        return (
                            <sprite key={index} position={[(icon.x/10), 4, icon.y/10]} scale={3} visible={true} onClick={()=>{
                                if(icon.click === 'next'){
                                    g.setCurrentFloor(g.NextPrev[g.NextPrev.indexOf(g.CurrentFloor) + 1])
                                }else{
                                    g.setCurrentFloor(g.NextPrev[g.NextPrev.indexOf(g.CurrentFloor) - 1])
                                }
                            }}>
                                <spriteMaterial attach="material" map={elevator} />
                            </sprite> 
                        )
                    
                    }
                    
                })
            
            }
        </>
    )
}

export default memo(ShowPathIcon)